export const API_ENDPOINTS = {
    AMAZON_PRODUCT_ASIN_SEARCH: '/get_amazon_info_details',
    AMAZON_PRODUCT_REVIEWS: '/get_amazon_info_reviews',
    AMAZON_PRODUCT_KEYWORD_SEARCH: '/get_amazon_keyword_details',
    MARKET_SEARCH: '/get_brand_details',
    MARKET_NEWS_SEARCH: '/get_search_brand_details',
    MARKET_PATENT_SEARCH: '/get_data_IP',
    DISTRIBUTOR_SEARCH: '/get_supplier',
    COMPETITIVE_STRATERGY_SEARCH:'/get_porterforces',
    COMPETITOR_ANALYZER_SEARCH:'/get_CompetitorAnalyzer',
    SWOT_ANALYZER:'/get_swot_analyzer',
    REVIEW_ANALYZER:'/get_reviewAnalyzer'
};